import initFormsSubmit from "../components/initFormsSubmit.js";
import initModals from "../components/initModals.js";

document.addEventListener("DOMContentLoaded", () => {

    initFormsSubmit();
    initModals();

    const formUploadElms = document.querySelectorAll('.form__upload');

    function humanFileSize(bytes) {
        if (bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const val = bytes / Math.pow(k, i);
        return `${val.toFixed(1)} ${sizes[i]}`;
    }

    function createFileUploadItem(uploadBlock, fileName, fileSize, MAX_BYTES) {

        const fileListItem = uploadBlock.querySelector('.form__upload_files');

        let sizeText = '';
        if (fileSize < MAX_BYTES) {
            sizeText = humanFileSize(fileSize);
        } else {
            sizeText = `<span class="file__error">File is too large (max ${humanFileSize(MAX_BYTES)})</span>`;
        }

        const fileItemHtml = `<div class="form__upload_item">
                                        <div class="file__item_wrapper">
                                            <div class="file__item_name">${fileName}</div>
                                            <div class="file__item_size">${sizeText}</div>
                                        </div>
                                        <button class="file__item_remove" type="button" aria-label="Remove file" data-file-remove></button>
                                    </div>`

        fileListItem.insertAdjacentHTML('beforeend', fileItemHtml);
    }

    formUploadElms.forEach((uploadBlock) => {
        const MAX_BYTES = 20 * 1024 * 1024; // 20 MB
        const fileInput = uploadBlock.querySelector('.form__upload_input');
        // const fileItem = uploadBlock.querySelector('.form__upload_item');


        fileInput.addEventListener('change', (e) => {
            const f = e.target.files[0];
            if (!f) {
                // nothing chosen
                return;
            }

            createFileUploadItem(uploadBlock, f.name, f.size, MAX_BYTES);
        });
    });

    document.addEventListener('click', (e) => {
        if (e.target.closest('[data-file-remove]')) {
            e.preventDefault();

            const fileItem = e.target.closest('.form__upload_item');
            const fileInput = fileItem.closest('.form__upload').querySelector('.form__upload_input');
            fileItem.remove();
            fileInput.value = '';
        }
    });

});
